import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login, isAuthenticated, user, isLoading } = useAuth();

  console.log('🖥️ Login Component - Renderizado');
  console.log('🔍 Estado actual - isAuthenticated:', isAuthenticated, 'user:', !!user, 'isLoading:', isLoading);

  // useEffect para detectar cuando el login es exitoso y forzar navegación
  useEffect(() => {
    console.log('🔄 Login Component - useEffect disparado');
    console.log('📊 Estado actual:', { isAuthenticated, user: !!user, isLoading });
    
    if (isAuthenticated && user && !isLoading) {
      console.log('✅ Login Component - Login exitoso detectado, el usuario será redirigido al CompanySelector');
      // App.js detectará este cambio y mostrará CompanySelector
      // No necesitamos hacer nada más aquí
    }
  }, [isAuthenticated, user, isLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('📝 Login Form - Submit iniciado');
    console.log('📧 Email del formulario:', email);
    
    setLoading(true);
    setError('');

    try {
      const result = await login(email, password);
      
      console.log('📥 Login Form - Resultado recibido:', result);
      
      if (result.success) {
        console.log('✅ Login Form - Éxito; App mostrará el selector de empresa');
        // No recargar: useAuth ya actualizó user/isAuthenticated y navega a /
      } else {
        console.log('❌ Login Form - Error, mostrando mensaje');
        setError(result.message || 'Error al iniciar sesión. Verifica tus credenciales.');
      }
    } catch (error) {
      console.error('🚨 Login Form - ERROR catch:', error);
      setError('Error de conexión. Verifica que el servidor esté funcionando.');
    } finally {
      setLoading(false);
      console.log('🏁 Login Form - Submit completado');
    }
  };

  // Agregar log para debug sin interferir con el renderizado
  if (isAuthenticated && user && !isLoading) {
    console.log('🚀 Login Component - Usuario ya autenticado, pero permitiendo que App.js maneje la navegación');
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-cyan-50 flex items-center justify-center py-8 lg:py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6 lg:space-y-8">
        {/* Logo y título */}
        <div className="text-center">
          <div className="mx-auto h-16 w-16 lg:h-20 lg:w-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
            <span className="text-white text-2xl lg:text-3xl font-bold">P</span>
          </div>
          <h2 className="mt-6 text-center text-2xl lg:text-3xl font-extrabold text-gray-900">
            Sistema de Planillas
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Inicia sesión para continuar
          </p>
        </div>

        {/* Formulario de login */}
        <div className="bg-white rounded-2xl shadow-xl p-6 lg:p-8 border border-gray-100">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Correo electrónico
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 lg:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors duration-200"
                placeholder="tu@email.com"
                disabled={loading}
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Contraseña
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 lg:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors duration-200"
                placeholder="••••••••"
                disabled={loading}
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                <p className="text-sm text-red-600">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full flex justify-center py-2 lg:py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
            >
              {loading ? (
                <div className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Iniciando sesión...
                </div>
              ) : (
                'Iniciar sesión'
              )}
            </button>
          </form>
        </div>

        {/* Footer */}
        <div className="text-center text-xs text-gray-500">
          <p>Sistema de Gestión de Planillas v1.0</p>
          <p className="mt-1">Desarrollado para empresas peruanas</p>
          <p className="mt-1 text-teal-600">Conectado al backend Laravel</p>
        </div>
      </div>
    </div>
  );
};

export default Login; 